import React from 'react';
import StarIcon from '@mui/icons-material/Star';
export function SocialProofStrip() {
  return <div className="bg-brand-purple text-white py-3 px-4" data-id="element-244">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 md:gap-6 text-center md:text-left" data-id="element-245">
        <div className="flex items-center gap-4" data-id="element-246">
          <div className="flex text-yellow-400" data-id="element-247">
            <StarIcon data-id="element-248" />
            <StarIcon data-id="element-249" />
            <StarIcon data-id="element-250" />
            <StarIcon data-id="element-251" />
            <StarIcon data-id="element-252" />
          </div>
          <div data-id="element-253">
            <p className="font-bold text-lg" data-id="element-254">4.9/5 calificación promedio</p>
          </div>
        </div>

        <div className="text-center" data-id="element-255">
          <p className="font-bold text-xl tracking-wide" data-id="element-256">
            +500 PERSONAS YA EMPEZARON
          </p>
          <p className="text-brand-cream/80 text-sm" data-id="element-257">
            A crear arte con sus propias manos
          </p>
        </div>

        <div className="flex gap-6 text-sm font-medium" data-id="element-258">
          <div className="flex items-center gap-2" data-id="element-259">
            <span className="text-2xl" data-id="element-260">📘</span>
            <span data-id="element-261">
              2 tomos
              <br data-id="element-262" />
              completos
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-263">
            <span className="text-2xl" data-id="element-264">🎁</span>
            <span data-id="element-265">
              4 bonos
              <br data-id="element-266" />
              incluidos
            </span>
          </div>
        </div>
      </div>
    </div>;
}